import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./assets/css/style.css"
import "./assets/css/FontAwesome/Css/all.min.css"
import "./assets/css/FontAwesome/Css/fontawesome.min.css"
import "cropperjs/dist/cropper.css";
import AppRouter from './Router/Route';
import Header from './components/Header';
import { useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect } from 'react';
import { requestForToken, onForegroundMessage } from "./fcm";


function App() {

  const location = useLocation();
  const authRoutes = [
    "/",
    "/login",
    '/forgot-password',
    '/verify-otp',
    "/reset-pass",
    "/terms",
    "/privacy"
  ];

  const footerRoutes = [
    '/details',
    "/reward-redeem",
    "/points-history",
    "/learning-list",
    "/read-learning",
    "/end-job",
    "/end-job-details",
    "/chat-list",
    "/new-chat-list",
    "/chats",
    "/profile",
    "/about-us",
    "/privacy-policy",
    "/terms-condition"
  ]

  const allKnownRoutes = [
    ...authRoutes,
    ...footerRoutes,
    "/home", "/leaderboard", "/rewards", "/reward-redeem",
    "/points-history", "/learning-list", "/read-learning", "/clock",
  ];

  const is404 = !allKnownRoutes.includes(location.pathname);
  const hideHeaderFooter = authRoutes.includes(location.pathname) || is404;
  const hideFooter = footerRoutes.includes(location.pathname);


  useEffect(() => {
    requestForToken();

    const unsubscribe = onForegroundMessage((payload) => {
      console.log("Foreground message:", payload);
      const { title, body } = payload?.notification || {};
      const message = body || title || "New notification";
      toast.info(title && body ? `${title}: ${body}` : message);
    });

    return () => unsubscribe();
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      {!hideHeaderFooter && <Header />}
      <div className={`${!hideHeaderFooter ? "main-wrapper" : ""} ${hideHeaderFooter || hideFooter ? "" : "content-wrapper"}`}>
        <AppRouter />
      </div>
      {!hideHeaderFooter && !hideFooter && <Footer />}
    </>
  );
}

export default App;
